/**
 * Entity MY Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';
import { useSessionStore } from '@/shared/stores/sessionStore';

// jurisdiction이 MY인지 확인하는 가드 (MY가 아니면 일반 Entity로 리다이렉트)
const checkJurisdictionMY = (to: any, from: any, next: any) => {
    const sessionStore = useSessionStore();
    const customerInfo = sessionStore.getCustomerInfo();
    
    if (customerInfo?.jurisdiction === 'MY') {
        // jurisdiction이 MY이면 Entity_my로 진행
        next();
    } else {
        // jurisdiction이 MY가 아니면 일반 Entity로 리다이렉트
        // 경로 변환: /Entity_my -> /Entity, /entity_my -> /entity
        let redirectPath = to.path.replace(/^\/Entity_my(\/|$)/, '/Entity$1').replace(/^\/entity_my(\/|$)/, '/entity$1');
        
        // 쿼리 파라미터와 해시 유지
        const query = to.query;
        const hash = to.hash;
        
        next({
            path: redirectPath,
            query: query,
            hash: hash,
            replace: true // 히스토리에 남기지 않음
        });
    }
};

export const entityMyRoutes: RouteRecordRaw[] = [
    {
        path: '/Entity_my',
        name: 'EntityMyList',
        component: () => import('./views/EntityListPage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Management (MY)',
            titleKey: 'entity.Entity Management',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // 소문자 경로도 지원
    {
        path: '/entity_my',
        name: 'EntityMyListLower',
        component: () => import('./views/EntityListPage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Management (MY)',
            titleKey: 'entity.Entity Management',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // create 경로는 :id 파라미터 라우트보다 먼저 정의되어야 함
    {
        path: '/Entity_my/create',
        name: 'EntityMyCreate',
        component: () => import('./views/EntityCreatePage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Create (MY)',
            titleKey: 'entity.Entity Create',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/entity_my/create',
        name: 'EntityMyCreateLower',
        component: () => import('./views/EntityCreatePage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Create (MY)',
            titleKey: 'entity.Entity Create',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // edit 경로도 :id보다 먼저 정의
    {
        path: '/Entity_my/:id/edit',
        name: 'EntityMyEdit',
        component: () => import('./views/EntityEditPage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Edit (MY)',
            titleKey: 'entity.Entity Edit',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/entity_my/:id/edit',
        name: 'EntityMyEditLower',
        component: () => import('./views/EntityEditPage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Edit (MY)',
            titleKey: 'entity.Entity Edit',
            requiresAuth: true,
            layout: 'default',
        },
    },
    // 마지막에 :id 파라미터 라우트 정의
    {
        path: '/Entity_my/:id',
        name: 'EntityMyDetail',
        component: () => import('./views/EntityDetailPage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Detail (MY)',
            titleKey: 'entity.Entity Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
    {
        path: '/entity_my/:id',
        name: 'EntityMyDetailLower',
        component: () => import('./views/EntityDetailPage.vue'),
        beforeEnter: checkJurisdictionMY,
        meta: {
            title: 'Entity Detail (MY)',
            titleKey: 'entity.Entity Detail',
            requiresAuth: true,
            layout: 'default',
        },
    },
];

export default entityMyRoutes;

